/**
 * TALKR — countdown, preuve sociale, exit popup, sticky cart, drawer (hooks)
 */
(function () {
  'use strict';

  var STORAGE_PREFIX = 'talkr_cd_end_';

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function initCountdown(root) {
    var el = root.querySelector('[data-talkr-countdown]');
    if (!el) return;
    var display = el.querySelector('[data-talkr-countdown-display]');
    var hours = parseFloat(el.getAttribute('data-duration-hours') || '3', 10);
    var productId = el.id ? el.id.replace('talkr-countdown-', '') : 'default';
    var key = STORAGE_PREFIX + productId;
    var end = parseInt(localStorage.getItem(key), 10);
    var now = Date.now();
    if (!end || end < now) {
      end = now + Math.round(hours * 3600000);
      localStorage.setItem(key, String(end));
    }

    function tick() {
      var left = Math.max(0, end - Date.now());
      var s = Math.floor(left / 1000);
      var h = Math.floor(s / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sec = s % 60;
      if (display) {
        display.textContent = pad(h) + ':' + pad(m) + ':' + pad(sec);
      }
      if (left <= 0) {
        end = Date.now() + Math.round(hours * 3600000);
        localStorage.setItem(key, String(end));
      }
    }

    tick();
    setInterval(tick, 1000);
  }

  function initWatchers(root) {
    var el = root.querySelector('[data-talkr-watchers]');
    if (!el) return;
    var textEl = el.querySelector('[data-talkr-watchers-text]');
    var min = parseInt(el.getAttribute('data-min') || '8', 10);
    var max = parseInt(el.getAttribute('data-max') || '24', 10);
    var pi = document.querySelector('[data-product-id]');
    var productId = pi ? String(pi.getAttribute('data-product-id') || '0') : '0';
    var seed = 0;
    for (var i = 0; i < productId.length; i++) {
      seed += productId.charCodeAt(i);
    }
    var n = min + (seed % (max - min + 1));
    if (textEl) {
      textEl.textContent = '👁 ' + n + ' personnes regardent ce produit';
    }
  }

  function initExitPopup() {
    var popup = document.querySelector('[data-talkr-exit-popup]');
    if (!popup) return;
    var delay = parseInt(popup.getAttribute('data-delay-ms') || '8000', 10);
    var shown = false;

    function open() {
      if (shown) return;
      shown = true;
      popup.removeAttribute('hidden');
      popup.classList.add('is-open');
    }

    function close() {
      popup.classList.remove('is-open');
      setTimeout(function() {
        popup.setAttribute('hidden', '');
      }, 300);
    }

    var closeBtn = popup.querySelector('[data-talkr-exit-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', close);
    }
    popup.addEventListener('click', function (e) {
      if (e.target === popup) close();
    });

    setTimeout(function () {
      if (!shown) open();
    }, delay);

    document.addEventListener(
      'mouseout',
      function (e) {
        if (!e.relatedTarget && e.clientY < 10 && !shown) open();
      },
      true
    );
  }

  function initStickyCart() {
    var bar = document.querySelector('[data-talkr-sticky-cart]');
    if (!bar) return;
    var at = parseInt(bar.getAttribute('data-scroll-at') || '300', 10);
    var btn = bar.querySelector('[data-talkr-sticky-add]');
    var mainSubmit = document.querySelector('button.product-form__submit[name="add"]');

    function onScroll() {
      if (window.scrollY >= at) {
        bar.removeAttribute('hidden');
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
        bar.setAttribute('hidden', '');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    if (btn && mainSubmit) {
      btn.addEventListener('click', function () {
        mainSubmit.click();
      });
    }
  }

  function initScrollReveal() {
    var elements = document.querySelectorAll('.talkr-section-heading, .talkr-section-sub, .talkr-cat-card, .talkr-product-card-wrap, .talkr-step, .talkr-review, .talkr-ig-grid__item, .talkr-qr__heading, .talkr-qr__rte, .talkr-final-cta');
    
    if (!elements.length || !window.IntersectionObserver) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      threshold: 0.1,
      rootMargin: "0px 0px -50px 0px"
    });

    elements.forEach(function(el, index) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.6s cubic-bezier(0.22, 1, 0.36, 1), transform 0.6s cubic-bezier(0.22, 1, 0.36, 1)';
      el.style.transitionDelay = (index % 4) * 0.1 + 's'; // Stagger effect
      observer.observe(el);
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    initCountdown(document);
    initWatchers(document);
    initExitPopup();
    initStickyCart();
    initScrollReveal();
  });
})();
